import { http } from '../../../../api/http';
import type { SolicitudRequerimiento } from '../types/solicitudRequerimiento.types';

export class SolicitudRequerimientoService {
  private static readonly BASE = '/compras/solicitud-requerimiento';

  public static async getAll(): Promise<SolicitudRequerimiento[]> {
    const response = await http.get(this.BASE);
    return response.data;
  }

  public static async getById(id: number): Promise<SolicitudRequerimiento> {
    const response = await http.get(`${this.BASE}/${id}`);
    return response.data;
  }

  public static async save(data: SolicitudRequerimiento): Promise<SolicitudRequerimiento> {
    const response = await http.post(this.BASE, data);
    return response.data;
  }

  public static async delete(id: number): Promise<boolean> {
    await http.delete(`${this.BASE}/${id}`);
    return true;
  }

  public static async aprobar(id: number, idUsuarioAprueba: number): Promise<SolicitudRequerimiento> {
    const response = await http.post(`${this.BASE}/${id}/aprobar?idUsuarioAprueba=${idUsuarioAprueba}`);
    return response.data;
  }
}
